import React from 'react';
import './Shop.css';

// Dynamically import all images and videos from the 'assets' folder
const importAll = (r) => r.keys().map(r);
const mediaFiles = importAll(require.context('../assets', false, /\.(png|jpe?g|svg|mp4|mov|MOV)$/i));

const Shop = () => {
  return (
    <div className="shop-container">
      <h1>Gallery</h1>
      <p>Discover our exclusive collection of media items.</p>
      <div className="media-grid">
        {mediaFiles.map((file, index) => (
          <div key={index} className="media-card">
            {file.match(/\.(mp4|mov|MOV)$/i) ? (
              <video controls muted className="media-content">
                <source src={file} type={file.match(/\.mp4$/i) ? 'video/mp4' : 'video/quicktime'} />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img src={file} alt={`media-${index}`} className="media-content" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Shop;